import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

import Signup from './signup'

library.add(fab, faEnvelope)

const Footer = () => (
  <div className="footer">
    <Container>
      <Row>
        <Col sm={{ size: 10, offset: 1 }}>
          <Row>
            <Col className="social" xs="auto">
              <a href="https://www.linkedin.com/company/topos.ai/">
                <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
              </a>
              <a href="https://medium.com/topos-ai">
                <FontAwesomeIcon icon={['fab', 'medium-m']} />
              </a>
              <a href="https://twitter.com/topos_ai">
                <FontAwesomeIcon icon={['fab', 'twitter']} />
              </a>
              <a href="mailto:info@topos.ai">
                <FontAwesomeIcon icon="envelope" />
              </a>
            </Col>
            <Col md={12} lg={8}>
              <Signup />
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
                <Col xs="auto" className="copywrite">
                  <p> All rights reserved © 2019 Topos Inc. </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </div>
)

export default Footer
